import React, { useEffect, useState, useRef } from "react";
import "./instructions.scss";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import clintlogo from "../../assets/images/default_avtar.png";
import EnglishInstruction from "../instructions/english";
import HindiInstraction from "./hindi";
import KanndaInstraction from "./kannda";
import FrenchInstruction from "./french";
import GermanInstruction from "./german";
import api from "../../api";
import Loader from "../loader";
import el_user from "../../assets/icons/el_user.svg";
import { setLanguageByInstitute } from "../../translation/i18";
// import { FullScreen, useFullScreenHandle } from "react-full-screen";
const Instractions = (props) => {
  const { t, i18n } = useTranslation();
  let languageJSON = [
    {
      id: 1,
      title: "Hindi",
    },
    {
      id: 2,
      title: "English",
    },
    {
      id: 3,
      title: "French",
    },
    {
      id: 4,
      title: "German",
    },
    {
      id: 5,
      title: "Kannada",
    },
  ];
  const [multiLanguageslist, setMultiLanguageslist] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState();
  const [language, setLanguage] = useState(() => {
    // Initialize language based on institute ID
    const instituteId = props.state?.institute_data?.institute_id;
    if (String(instituteId) === "106343") {
      return "French";
    }
    return "English";
  });
    const [startingBtnText, setStartingBtnText] = useState(t("common.startTest"));
  const [testEnabled, setTestEnabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [accept_terms, SetAccept_terms] = useState(false);
  const [serverTimeStamp, setServerTimeStamp] = useState(0);
  const [leftHours, setLeftHours] = useState("");
  const [leftDays, setLeftDays] = useState("");
  const [leftMins, setLeftMins] = useState("");
  const [leftSecs, setLeftSecs] = useState("");

  // Warm-up preload states
  const beginTestTimeoutRef = useRef(null);
  const [isBeginTestCalled, setIsBeginTestCalled] = useState(false);

  // Get warm-up duration from API (buffer_duration in minutes), default to 0 if null/"0"
  const getWarmUpDuration = () => {
    const bufferDuration = props.state.test_data?.buffer_duration;
    console.log("props.state.test_data?.buffer_duration;",props.state.test_data?.buffer_duration)
    if (!bufferDuration || bufferDuration === "0" || bufferDuration === 0) {
      return 0;
    }
    return parseInt(bufferDuration, 10) * 60; // Convert minutes to seconds
  };
  // const handle = useFullScreenHandle();

  
  useEffect(() => {
    if (
      props.state.test_data == undefined ||
      props.state.student_data == undefined
    ) {
      window.location.replace("/");
    } else {
      if (props.state.test_data.is_multi_lingual === 1) {
        // Show all 5 languages in dropdown: Hindi, English, French, German, Kannada
        const allLanguages = [
          { id: 1, title: "Hindi" },
          { id: 2, title: "English" },
          { id: 3, title: "French" },
          { id: 4, title: "German" },
          { id: 5, title: "Kannada" }
        ];

        setMultiLanguageslist(allLanguages);
      }
  
      // Start button logic (unchanged)
      if (props.state.student_data.userid !== 1234567890) {
        if (props.state.test_data.test_type_id === 2) {
          if (
            props.state.attempt_data &&
            props.state.attempt_data.attempt_count > 0
          ) {
            setStartingBtnText(t("common.restartTest"));
          } else if (props.state.attempt_data.attempt_data !== null) {
            setStartingBtnText(t("common.resumeTest"));
          } else {
            setStartingBtnText(t("common.startTest"));
          }
        } else {
          if (props.state.attempt_data.attempt_data == null) {
            setStartingBtnText(t("common.startTest"));
          } else {
            setStartingBtnText(t("common.resumeTest"));
          }
        }
      } else {
        setStartingBtnText(t("common.startTest"));
      }
  
      initTimer();
    }
  }, []);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (beginTestTimeoutRef.current) {
        clearTimeout(beginTestTimeoutRef.current);
      }
    };
  }, []);

  // Effect to set language based on institute ID
  useEffect(() => {
    if (props.state?.institute_data?.institute_id) {
      const instituteId = props.state.institute_data.institute_id;
      const langCode = setLanguageByInstitute(instituteId);

      // Set the language display name based on the language code
      const langName = langCode === "fr" ? "French" : "English";
      setLanguage(langName);

      // For institute 106343, also set preferred_language for questions
      if (String(instituteId) === "106343") {
        const frenchLangId = 3; // French ID from languageJSON
        localStorage.setItem("preferred_language", frenchLangId);
        props.dispatch({
          type: "CHANGES_LANGUAGE",
          languageSelected: frenchLangId,
        });
      }
    }
  }, [props.state?.institute_data]);
  
  
  const changeByLanguage = (langTitle) => {
    setLanguage(langTitle);

    // Change i18n language based on selected language
    const langCode = langTitle.toLowerCase() === "english" ? "en" :
                     langTitle.toLowerCase() === "hindi" ? "hi" :
                     langTitle.toLowerCase() === "french" ? "fr" :
                     langTitle.toLowerCase() === "german" ? "de" :
                     langTitle.toLowerCase() === "kannada" ? "kn" : "fr";

    i18n.changeLanguage(langCode);

    // Match language object from your static language list
    const selectedLangObj = languageJSON.find(l => l.title === langTitle);

    if (selectedLangObj) {
      // Save numeric ID in localStorage
      localStorage.setItem("preferred_language", selectedLangObj.id);

      // Dispatch correct ID to Redux
      props.dispatch({
        type: "CHANGES_LANGUAGE",
        languageSelected: selectedLangObj.id,
      });

      // Update button text based on current state
      if (props.state.test_data.test_type_id === 2) {
        if (props.state.attempt_data && props.state.attempt_data.attempt_count > 0) {
          setStartingBtnText(t("common.restartTest"));
        } else if (props.state.attempt_data.attempt_data !== null) {
          setStartingBtnText(t("common.resumeTest"));
        } else {
          setStartingBtnText(t("common.startTest"));
        }
      } else {
        if (props.state.attempt_data.attempt_data == null) {
          setStartingBtnText(t("common.startTest"));
        } else {
          setStartingBtnText(t("common.resumeTest"));
        }
      }
    }
  };

  // Session header helper for beginTest API
  const setSessionHeaders = () => {
    let sessionKey = "";
    let accountdata = props.state.institute_data;
    let testdata = props.state.test_data;
    let studentdata = props.state.student_data;
    if (
      studentdata != undefined &&
      testdata != undefined &&
      accountdata != undefined
    ) {
      sessionKey =
        studentdata.userid +
        ":" +
        testdata.test_id +
        ":" +
        accountdata.account_id +
        ":" +
        props.state.session_key;
      sessionKey = btoa(sessionKey);
      return sessionKey;
    }
  };

  // Process beginTest API response and dispatch to Redux
  const processBeginTestData = (data) => {
    if (data.languages != undefined) {
      props.dispatch({
        type: "CHANGE_LANGUAGE_QUESTION",
        test_language: data.languages,
      });
    }

    let preferredLangId = parseInt(localStorage.getItem("preferred_language"));
    if (
      !preferredLangId ||
      isNaN(preferredLangId) ||
      !data.languages?.some((l) => l.id === preferredLangId)
    ) {
      preferredLangId = 1;
      localStorage.setItem("preferred_language", preferredLangId);
    }

    props.dispatch({
      type: "CHANGES_LANGUAGE",
      languageSelected: preferredLangId,
    });

    props.dispatch({
      type: "CURRENT_SECTION",
      current_section_id: data.current_section_id,
    });

    props.dispatch({ type: "QUESTIONS_DATA", ques_data: data.ques_data });

    props.dispatch({
      type: "TEST_SETTING",
      test_settings: data.test_settings,
    });

    if (data.subjects_data.length > 0) {
      props.dispatch({
        type: "SUBJECT_DATA",
        subjects_data: data.subjects_data,
      });
    }

    if (props.state.student_data.userid !== 1234567890) {
      if (props.state.test_data.test_type_id == 2) {
        if (data?.test_settings?.is_show_score == 1) {
          if (
            data.ques_data.filter(
              (el) => el.is_auto_evaluate == 0 && el.ques_type_id == 2
            ).length < 1
          ) {
            props.dispatch({ type: "SHOW_SCORECARD", showscorecard: true });
          } else {
            props.dispatch({ type: "SHOW_SCORECARD", showscorecard: false });
          }
        } else {
          props.dispatch({ type: "SHOW_SCORECARD", showscorecard: false });
        }
      } else {
        if (
          data.ques_data.filter(
            (el) => el.is_auto_evaluate == 0 && el.ques_type_id == 2
          ).length < 1
        ) {
          props.dispatch({ type: "SHOW_SCORECARD", showscorecard: true });
        } else {
          props.dispatch({ type: "SHOW_SCORECARD", showscorecard: false });
        }
      }
    }

    props.dispatch({
      type: "ATTEMPT_DATA",
      attempt_data: data.attempt_data.attempt_data,
    });

    if (
      data.attempt_data.attempt_data != null &&
      Object.keys(data.attempt_data.attempt_data).length > 0
    ) {
      let answerJsonParsed = JSON.parse(data.attempt_data.attempt_data.answer_json);

      let status_arr = answerJsonParsed.question_state.split("#");
      let questions = answerJsonParsed.questions.split("#");
      let subjectData = answerJsonParsed.subjective_answer;

      props.dispatch({
        type: "SUBJECTIVE_ANSWERS",
        subjective_answer: [...subjectData],
      });

      if (status_arr.length > 0) {
        const questionStatus = [];
        questions.forEach((el, i) => {
          questionStatus.push({
            ques_id: el,
            status_number: parseInt(status_arr[i], 10),
          });
        });
        props.dispatch({
          type: "CHANGES_STATUS",
          questionstatus: questionStatus,
        });
      }

      let attempt_time = answerJsonParsed.attempt_time.split("#");
      props.dispatch({
        type: "ATTEMPT_TIME",
        attempt_time: attempt_time,
      });

      let answerJson = answerJsonParsed.answers.split("#");
      props.dispatch({ type: "SET_ANSWER", answers_json: answerJson });

      let bookMarked = answerJsonParsed.is_bookmark.split("#");
      props.dispatch({
        type: "SET_BOOKMARKED",
        is_bookmarked: bookMarked,
      });
    }

    props.dispatch({ type: "BEGIN_TEST_PRELOAD" });
    props.dispatch({ type: "TRIGGER_TIMER_UPDATE" });
  };

  // Call beginTest API
  const callBeginTestApi = () => {
    if (isBeginTestCalled || props.state.isTestDataPreloaded) {
      return;
    }

    setIsBeginTestCalled(true);

    let request = {
      url: `/v1/examPanel/beginTest`,
      headers: {
        "X-Device-Info": btoa(JSON.stringify(window.navigator.userAgent)),
        "X-Device-Key": localStorage.getItem("identityKey"),
        "X-Session-Key": setSessionHeaders(),
      },
    };

    api
      .getAuthTZ(request)
      .then((response) => {
        if (response.data["validate"]) {
          let data = response.data["data"];
          processBeginTestData(data);
        }
      })
      .catch((err) => {
        // Reset flag so it can be retried on panel page
        setIsBeginTestCalled(false);
        console.error("BeginTest preload failed:", err);
      });
  };

  // Schedule beginTest API call at random time during warm-up window
  const scheduleBeginTestCall = (serverTime, testStartTime) => {
    // Don't schedule if already called or preloaded
    if (isBeginTestCalled || props.state.isTestDataPreloaded) {
      return;
    }

    const warmUpDuration = getWarmUpDuration();
    const currentTime = serverTime;

    // If no buffer duration (null/0), call API immediately
    if (warmUpDuration === 0) {
      callBeginTestApi();
      return;
    }

    const warmUpStartTime = testStartTime - warmUpDuration;

    // Case 1: Already past test start time → call immediately (fallback)
    if (currentTime >= testStartTime) {
      callBeginTestApi();
      return;
    }

    // Case 2: In warm-up window → random delay within remaining time
    if (currentTime >= warmUpStartTime) {
      const remainingWindow = testStartTime - currentTime;
      const maxDelay = remainingWindow * 0.8; // Use 80% as buffer
      const randomDelay = Math.random() * maxDelay;

      beginTestTimeoutRef.current = setTimeout(() => {
        callBeginTestApi();
      }, randomDelay * 1000);
      return;
    }

    // Case 3: Before warm-up window → schedule for random time in warm-up
    const timeUntilWarmUp = warmUpStartTime - currentTime;
    const randomTimeInWarmUp = Math.random() * warmUpDuration * 0.8;
    const totalDelay = timeUntilWarmUp + randomTimeInWarmUp;

    beginTestTimeoutRef.current = setTimeout(() => {
      callBeginTestApi();
    }, totalDelay * 1000);
  };

  const initTimer = async () => {
    let SrvrTimeStamp = 0;
    setLoading(true);
    let request = {
      url: `/v1/examPanel/time`,
      headers: {
        "X-Device-Info":
          "eyJkZXZpY2UiOiJVbmtub3duIiwiYnJvd3NlciI6IkNocm9tZSA5OS4wLjQ4NDQuODIiLCJvcyI6IldpbmRvd3Mgd2luZG93cy0xMCJ9",
        "X-Device-Key": "ozfinggcn7",
      },
    };
    await api.getAuthTZ(request).then(
      (response) => {
        setLoading(false);
        setServerTimeStamp(response.data.timestamp);
        SrvrTimeStamp = response.data.timestamp;
        sessionStorage.setItem("exam-date", serverTimeStamp);

        // Schedule beginTest API call during warm-up window
        scheduleBeginTestCall(
          response.data.timestamp,
          props.state.test_data.test_start_timestamp
        );
      },
      (errors) => {
        setLoading(false);
      }
    );
    const x = setInterval(function () {
      SrvrTimeStamp = SrvrTimeStamp + 1;
      let distance = props.state.test_data.test_start_timestamp - SrvrTimeStamp;
      let formattedLeftTimeToStart =
        Math.floor(distance / 3600) +
        " : " +
        ("0" + (Math.floor(distance / 60) % 60)).slice(-2) +
        " : " +
        ("0" + (distance % 60)).slice(-2);
      let leftHours = Math.floor(distance / 3600);
      let leftDays = Math.floor(leftHours / 24);
      let leftMins = ("0" + (Math.floor(distance / 60) % 60)).slice(-2);
      let leftSecs = ("0" + (distance % 60)).slice(-2);

      setLeftDays(leftDays);
      setLeftHours(leftHours);
      setLeftMins(leftMins);
      setLeftSecs(leftSecs);
      if (distance <= 0) {
        clearInterval(x);
        setTestEnabled(true);
      }
    }, 1000);
  };

  const renderDescription = (description) => {
    const lines = description.split('\r\n');
    let isOrderedList = false; 
    let orderedListItems = [];

    return lines.map((line, index) => {
      const boldMatch = line.match(/\*\*(.*?)\*\*/);
    if (boldMatch) {
      line = line.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
    }

    const headingMatch = line.match(/^(#{1,6})\s*(.*?)$/);  
    if (headingMatch) {
      const level = headingMatch[1].length;
      line = `<h${level}>${headingMatch[2]}</h${level}>`;
    }

    const codeBlockMatch = line.match(/^```([\s\S]*?)```$/); 
    if (codeBlockMatch) {
      line = `<pre><code>${codeBlockMatch[1]}</code></pre>`;
    }

    const italicsMatch = line.match(/:_([^:]+):_/); 
    if (italicsMatch) {
      line = line.replace(/:_([^:]+):_/g, "<em>$1</em>");
    }

    const orderedListMatch = line.match(/^(\d+)\.\s+(.*)$/);
    if (orderedListMatch) {
      if (!isOrderedList) {
        isOrderedList = true;
        orderedListItems.push(`<ol><li>${orderedListMatch[2]}</li>`);
      } else {
        orderedListItems.push(`<li>${orderedListMatch[2]}</li>`);
      }
    } else {
      if (isOrderedList) {
        orderedListItems.push('</ol>');
        isOrderedList = false;
      }
    }

    if (!orderedListMatch) {
      if (isOrderedList) {
        return orderedListItems.join('');
      }
    }

      // const imageMatch = line.match(/!\[([^\]]*)\]\((https?:\/\/[^\)]+)\s*"(.*?)"\)/)                            
      // if (imageMatch) {
      //   return <img key={index} src={imageMatch[2]} alt={imageMatch[1]} title={imageMatch[3]} style={{ width: "100%", height: "auto" }} />;
      // }
    //   const imageMatch = line.match(/!\[([^\]]*)\]\((https?:\/\/[^\s\)]+)(?:\s+"([^"]+)")?\)/);
    // if (imageMatch) {
    //   // Replace with an HTML <img> tag
    //   line = line.replace(/!\[([^\]]*)\]\((https?:\/\/[^\s\)]+)(?:\s+"([^"]+)")?\)/g, (match, alt, url, title) => {
    //     return `<img src="${url}" alt="${alt}" ${title ? `title="${title}"` : ""} style={{ width: "100%", height: "auto" }}/>`;
    //   });
    // }
    line = line.replace(/!\[([^\]]*)\]\((https?:\/\/[^\s\)]+)(?:\s+"([^"]+)")?\)/g, (match, alt, url, title) => {
      return `<img src="${url}" alt="${alt}" style="width: 100%; height: auto;" ${title ? `title="${title}"` : ""} />`;
    });

    // Match and replace links
    line = line.replace(/\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/g, (match, text, url) => {
      return `<a href="${url}" target="_blank" style="width: 100%; height: auto;" rel="noopener noreferrer">${text}</a>`;
    });
      const linkMatch = line.match(/\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/);
    if (linkMatch) {
      line = line.replace(/\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/g, `<a href="$2" target="_blank" rel="noopener noreferrer">${linkMatch[1]}</a>`);
    }
      return <div key={index} dangerouslySetInnerHTML={{ __html: line }} />;
    });
  };

  return (
    <>
      {loading && (
        <div>
          <Loader />
        </div>
      )}

      <div class="s1-v">
        <div class="header">
          <div>
            <a href="#">
              <button>{t("common.onlineTest")}</button>
            </a>
          </div>
          <p>
            {props.state.institute_data.account_name !== ""
              ? props.state.institute_data.account_name
              : props.state.client_name}
          </p>
          {props.state.student_data.userid == 1234567890 &&
            !props.state.registrationdata && (
              <a>
                <button>{t("common.testPreview")}</button>
              </a>
            )}
        </div>
        <div class="height">
          <div class="h1-gg">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItem: "center",
                height: "35px",
                marginBottom: "5px",
                borderBottom: "1px solid #ddd",
              }}
            >
              <p
                className="instructionTitle"
                style={{ marginBottom: "20px", marginTop: "10px" }}
              >
{t("instructions.title")}
              </p>
              {props.state.test_data.is_multi_lingual == 1 &&
                multiLanguageslist.length && (
                  <span className="float-right" style={{ marginTop: "4px" }}>
                    <select
  name="language-select"
  className="custom-form-input"
  value={language}
  onChange={(event) => changeByLanguage(event.target.value)}
>
  {multiLanguageslist.map((lang) => (
    <option key={lang.title} value={lang.title}>
      {lang.title}
    </option>
  ))}
</select>

                  </span>
                )}
            </div>
            <div>
              <div style={{ height: "90%" }}>
                {language === "English" && (
                  <EnglishInstruction
                    instruction={
                      props.state.test_data.instruction_content == null
                        ? atob(
                            props.state.test_data.instruction_description
                          ).replace(/(<([^>]+)>)/gi, "")
                        :
                        renderDescription(props.state.test_data.instruction_content[0]?.description || "")
                    }
                  />
                )}
                {language === "Hindi" && (
                  <HindiInstraction
                    instruction={
                      props.state.test_data.instruction_content == null
                        ? atob(
                            props.state.test_data.instruction_description
                          ).replace(/(<([^>]+)>)/gi, "")
                        :
                        renderDescription(props.state.test_data.instruction_content[0]?.description || "")
                    }
                  />
                )}
                {language === "French" && (
                  <FrenchInstruction
                    instruction={
                      props.state.test_data.instruction_content == null
                        ? atob(
                            props.state.test_data.instruction_description
                          ).replace(/(<([^>]+)>)/gi, "")
                        :
                        renderDescription(props.state.test_data.instruction_content[0]?.description || "")
                    }
                  />
                )}
                {language === "German" && (
                  <GermanInstruction
                    instruction={
                      props.state.test_data.instruction_content == null
                        ? atob(
                            props.state.test_data.instruction_description
                          ).replace(/(<([^>]+)>)/gi, "")
                        :
                        renderDescription(props.state.test_data.instruction_content[0]?.description || "")
                    }
                  />
                )}
                {language === "Kannada" && (
                  <KanndaInstraction
                    instruction={
                      props.state.test_data.instruction_content == null
                        ? atob(
                            props.state.test_data.instruction_description
                          ).replace(/(<([^>]+)>)/gi, "")
                        :
                        renderDescription(props.state.test_data.instruction_content[0]?.description || "")
                    }
                  />
                )}
                {props.state.test_data.is_multi_lingual == 1 &&
                  multiLanguageslist.length && (
                    <div>
                        <div className="text-danger">
                          {t("instructions.multiLanguageNote")}
                        </div>
                    </div>
                  )}
              </div>
            </div>
            {testEnabled == true && (
              <label
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "baseline",
                }}
              >
                <input
                  type="checkbox"
                  id="en_ch"
                  onChange={(event) =>
                    event.target.checked == true
                      ? SetAccept_terms(true)
                      : SetAccept_terms(false)
                  }
                />
                <span
                  className="confirmationText"
                  style={{
                    marginLeft: "5px",
                    opacity: accept_terms ? "1.0" : "0.5",
                  }}
                >
                  {t("instructions.confirmation")}
                </span>
              </label>
            )}
            {testEnabled == false && (
              <div className="row col-md-12 text-center countdown-clock">
                <p className="label">{t("common.examStartsIn")}</p>
                <div className="d-block timer" style={{ width: "100%" }}>
                  <div className="d-inline-block clock-pallet">
                    <p className="left-day left-time-value">{leftDays}</p>
                    <p className="left-time-label">{t("common.days")}</p>
                  </div>
                  <div className="d-inline-block clock-pallet">
                    <p className="left-hours left-time-value">{leftHours}</p>
                    <p className="left-time-label">{t("common.hours")}</p>
                  </div>
                  <div className="d-inline-block clock-pallet">
                    <p className="left-minutes left-time-value">{leftMins}</p>
                    <p className="left-time-label">{t("common.minutes")}</p>
                  </div>
                  <div className="d-inline-block clock-pallet">
                    <p className="left-seconds left-time-value">{leftSecs}</p>
                    <p className="left-time-label">{t("common.seconds")}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div class="name_details">
            <img src={el_user} />
            <div class="br"></div>
            <p>{t("common.signedInAs")}</p>

            {props.state.student_data.userid == 1234567890 ? (
              <span>{props.state.registrationdata?.name ?? "User"}</span>
            ) : (
              <span>{props.state.student_data.name}</span>
            )}
            <div class="br"></div>
            {/* <p>Mobile Number</p>
          {props.state.student_data.userid == 1234567890 ? <span>{props.state.registrationdata?.number ?? "1234567890"}</span> : <span>{props.state.student_data.phone}</span>} */}
          </div>
        </div>

        <button
          style={{ opacity: accept_terms ? "1.0" : "0.5" }}
          onClick={() => window.location.replace("/panel")}
          disabled={!accept_terms}
        >
          {startingBtnText}
        </button>
      </div>

      {/* </FullScreen> */}
    </>
  );
};
const mapStateToProps = (state) => ({ state: state });
export default connect(mapStateToProps)(Instractions);
